import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import hostList from "../config/api_host.js";

Vue.use(VueLocalStorage);

// 共用變數
export const LogCenter = {
  isLock: false,
  addOperationToLog: function (operation) {
    var operationLog = [];
    var logData = this.getLogDate();
    if (logData != null) {
      operationLog = logData;
    }
    operation.date = new Date();
    operation.Status = String(operation.Status);
    operation.ApiName = operation.ApiName?.replaceAll(
      hostList["PRIVATE_HOST"],
      ""
    )
      .replaceAll(hostList["WEB_HOST"], "")
      ?.replaceAll("api/", "");
    //operation.Msg = vm.$dataCeneter.user.clientsystem;
    operation.Msg = operation.Msg;
    operation.Platform = "WebApi";
    operation.InputValue = JSON.stringify(operation.InputValue);

    // Pass 原則，特定的API不紀錄
    var isPass = false;
    if (
      operation.ApiName.indexOf("API-GroupProg-Default") != -1 ||
      operation.ApiName.indexOf("API-User-Permission") != -1 ||
      operation.ApiName.indexOf("detail") != -1 ||
      operation.ApiName.indexOf("list") != -1 ||
      operation.ApiName.indexOf("List") != -1 ||
      operation.ApiName.indexOf("Get") != -1 ||
      operation.ApiName.indexOf("get") != -1 ||
      operation.ApiName.indexOf("all") != -1 ||
      operation.ApiName.indexOf("select") != -1 ||
      operation.ApiName.indexOf("query") != -1 ||
      operation.ApiName.indexOf("search") != -1
    ) {
      isPass = true;
    }

    if (
      operation.ApiName.indexOf("chang") != -1 ||
      operation.ApiName.indexOf("update") != -1 ||
      operation.ApiName.indexOf("Update") != -1 ||
      operation.ApiName.indexOf("nsert") != -1
    ) {
      // 如果 有這些關鍵字還是要記錄
      isPass = false;
    }

    if (isPass) {
      return;
    }

    operation.content = null;
    // 如果InputValue 超過100字就截斷
    if (operation.InputValue?.length ?? 0 > 300) {
      let tempInput = operation.InputValue;
      operation.InputValue = tempInput.substring(0, 300);
      // 還是全部記錄
      operation.content = tempInput.substring(0, 12000);
    }
    if (operation.Msg?.length ?? 0 > 500) {
      operation.Msg = operation.Msg.substring(0, 499);
    }
    operationLog.push(operation);

    // 将操作记录保存到Cookie中
    this.saveLogToCookie(operationLog);

    setTimeout(
      function () {
        // 3秒後自動送出 檢查 operationLog date 更現在時間是否超過5秒
        // 有超過就送出
        var logData = this.getLogDate();
        if (logData != null) {
          var now = new Date();
          var isSend = false;
          for (let index = 0; index < logData.length; index++) {
            const element = logData[index];
            if ((now - new Date(element.date)) / 1000 > 3) {
              isSend = true;
              break;
            }
          }
          if (isSend && this.isLock == false) {
            this.sendLogToAPI();
          }
        }
      }.bind(this),
      3000
    );
  },
  saveLogToCookie: function (operationLog) {
    localStorage.setItem(
      "operationLog",
      encodeURIComponent(JSON.stringify(operationLog))
    );
    var data = localStorage.getItem("operationLog");
  },
  getLogDate() {
    var data = localStorage.getItem("operationLog");

    if (data != null && data != "" && data != "undefined") {
      const logString = decodeURIComponent(data);
      const logData = JSON.parse(logString);
      return logData;
    } else {
      return null;
    }
  },
  sendLogToAPI: function () {
    this.isLock = true;
    // 获取Cookie中的操作记录的URL编码字符串
    // console.log("sendLogToAPI");
    // 进行URL解码并将JSON字符串转为对象
    var logData = this.getLogDate();
    // console.log(logData);

    let url = vm.$httpService.api.SaveApiLogList;
    var headers = {};
    if (vm.$dataCeneter != null) {
      var user = vm.$dataCeneter.getData();
      if (user.loginToken != null) {
        headers["Token"] = user.loginToken;
      }
    }
    $.ajax({
      type: "POST",
      contentType: "application/json",
      // dataType: promiseData.dataType ?? "json",
      headers: headers,
      data: JSON.stringify(logData),
      async: true,
      url: url,
    })
      .done(
        function (responseData, status, xhr) {
          if (responseData.success == true) {
            // 送完後清空
            this.saveLogToCookie([]);

            this.isLock = false;
          } else {
            this.saveLogToCookie([]);

            this.isLock = false;
          }
        }.bind(this)
      )
      .fail(function (xhr, status, err) {});
  },
};
